export default [
    {
        value: "Computador",
        text: "Computador"
    },
    {
        value: "EquipamentoDeEletroeletronico",
        text: "Equipamento Eletroeletrônico"
    },
    {
        value: "FerramentaDeLaboratorio",
        text: "Ferramenta de Laboratório"
    },
    {
        value: "Impressora",
        text: "Impressora"
    },
    {
        value: "MaterialBibliografico",
        text: "Material Bibliográfico"
    },
    {
        value: "Scanner",
        text: "Scanner"
    },
    {
        value: "Software",
        text: "Software"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]